import { env } from '../libs/env';

export default {

  // 获取国家ID，主要为了三个环境返回不同的国家ID
  envCountryIdMap: {
    cambodia: {
      0: 10010,
      1: 10009,
      2: 10009,
    },
    america: {
      2: 10011,
      1: 10011,
      0: 10016,
    },
    canada: {
      2: 10020,
      1: 10020,
      0: 10023,
    },
  },
  getCountryId(country_key) {
    return this.envCountryIdMap[country_key][env];
  },
};



// WEBPACK FOOTER //
// ./src/services/country-service.js